import styles from './refreshButton.module.css';
import { ReactComponent as RefreshIcon } from '../../../assets/icons/refreshIcon.svg';
import { toKebabCase } from '../../../utils/casing';
import { WithTestId } from '../../../types';
import { ReactNode } from 'react';

export interface RefreshButtonProps extends WithTestId {
  text?: string | ReactNode;
}

const RefreshButton = ({ dataTestIdPrefix, text }: RefreshButtonProps) => (
  <button
    className={styles.refreshButton}
    onClick={() => window.location.reload()}
    data-testid={toKebabCase(dataTestIdPrefix, 'refreshButton')}
  >
    <RefreshIcon />
    {text}
  </button>
);

export default RefreshButton;
